module.exports = __webpack_public_path__ + "static/media/519.38d84daf.jpg";